"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_1 = require("react-router");
var map_types_1 = require("./map.types");
var map_pin_component_1 = __importDefault(require("./map-pin.component"));
var pin_container_component_1 = __importDefault(require("./pin-container.component"));
var InstallationPinContainer = function (props) {
    var location = props.location, url = props.url, children = props.children, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, _a = props.installationStatus, installationStatus = _a === void 0 ? map_types_1.InstallationStatus.ALL_GOOD : _a, _b = props.numberInCluster, numberInCluster = _b === void 0 ? 0 : _b, _c = props.numberOfAlerts, numberOfAlerts = _c === void 0 ? 0 : _c, _d = props.numberOfWarnings, numberOfWarnings = _d === void 0 ? 0 : _d, isActive = props.isActive;
    var history = react_router_1.useHistory();
    var handleClick = function () {
        if (onClick)
            onClick();
        else if (url) {
            history.push(url);
        }
    };
    var pinProps = {
        onClick: handleClick,
        status: installationStatus,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        isActive: isActive,
    };
    if (numberInCluster > 0) {
        pinProps.cluster = { numberInCluster: numberInCluster, numberOfAlerts: numberOfAlerts, numberOfWarnings: numberOfWarnings };
    }
    return (react_1.default.createElement(pin_container_component_1.default, { location: location },
        react_1.default.createElement(map_pin_component_1.default, __assign({}, pinProps), children)));
};
InstallationPinContainer.displayName = 'PinContainer';
exports.default = InstallationPinContainer;
//# sourceMappingURL=installation-pin-container.component.js.map